module.exports = __webpack_public_path__ + "static/media/firstam_angela_fletcher.bc92ff81.jpg";